<template>
  <div class="main_body livestream_page">
    <section id="hero_section">
      <div class="container">
        <navbar></navbar>
        <div class="main_logo">
          <img src="@/assets/images/Logo-011.png" alt="Logo-011.png">
        </div>
        <section class="contact_section">
          <div class="heading_section">
            <h3>Signup</h3>
            <!-- <h4>All questions will be answered in the order they were received</h4> -->
          </div>
          <div class="row">
            <div class="form_wrapper">
              <form @submit.prevent="signup">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                      <label for="name">Name</label>
                    </div>
                    <div class="col-md-9">
                      <input type="text" class="form-control" required id="name" v-model="form.name"
                        placeholder="Your Name" name="name">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                      <label for="email">Email</label>
                    </div>
                    <div class="col-md-9">
                      <input type="email" class="form-control" required id="email" v-model="form.email"
                        placeholder="your Email" name="email">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                      <label for="password">Password</label>
                    </div>
                    <div class="col-md-9">
                      <input type="password" class="form-control" required id="password" v-model="form.password"
                        placeholder="Password" name="password">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                      <label for="password">Confirm Password</label>
                    </div>
                    <div class="col-md-9">
                      <input type="password" class="form-control" required id="password" v-model="form.password_confirmation"
                        placeholder="Confirm Password" name="password">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3 pt-3">
                  </div>
                  <div class="col-md-9">
                    <button type="submit" :disabled="this.$store.getters.apiStatus === 'loading'"
                      class="btn btn_submit">
                      <div v-if="this.$store.getters.apiStatus !== 'loading'">Signup</div>
                      <div v-else class="loader">
                        <Loader></Loader>
                      </div>
                    </button>

                    <div class="mt-2">
                      <router-link class="redirect-link" to="/login">Already have an account? Login</router-link>
                    </div>
                  </div>
                </div>

              </form>
            </div>

          </div>
        </section>

        <social-links />
      </div>
    </section>
  </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import SocialLinks from '../components/SocialLinks.vue'
export default {
  components: {
    Navbar,
    SocialLinks
  },
  name: 'Signup',
  data () {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      }
    }
  },
  methods: {
    signup () {
      if (this.form.password !== this.form.password_confirmation) { this.$toast.error('Passwords do not match!'); return }
      this.$store
        .dispatch('signup', this.form)
        .then(() => {
          this.$store.dispatch('login', {email: this.form.email, password: this.form.password}).then(() => {
            this.$router.push('/')
            this.$toast.success('Account created!')
          }).catch((err) => {
            this.$toast.error(err.response.data.message)
            console.log(err.response)
          })
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
        })
    }
  }
}

</script>

<style scoped>
.btn_submit {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Signup.vue